import axios from 'axios';

// search vat input api
export async function searchCurrencyAPI(Data) {
	let currencylist = [];
	const currencyVal = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/currency/search/?currencyName=${currencyVal}`,
			data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		currencylist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return currencylist;
}

// check existing vat input api
export async function getCurrencyAPI(Data) {
	let currencylist = [];
	const currencyName = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/currency/getcurrency/?currencyName=${currencyName}`,
			data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		currencylist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return currencylist;
}

//create status api
export async function createCurrencyAPI(Data, userID) {
	let currencyData = [];
	try{
		const axiosResponse = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/currency/create/`,
			data: {Data, userID}
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		currencyData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return currencyData;
}

//update status api
export async function updateCurrencyAPI(Data, currencyID, userID) {
	let currencyData = [];
	try{
		const axiosResponse = await axios({
			method: 'PUT',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/currency/update/?currencyID=${currencyID}&userID=${userID}`,
			data: Data
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		currencyData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return currencyData;
}